module.exports = function() {
  return new Worker(__webpack_public_path__ + "45baaf372475140f74a5.worker.js");
};